import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Mail, RefreshCcw, Sparkles } from "lucide-react";
import { UniHeader } from "@/pages/university/_lmsShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/launch`;

export default function AdminInterests() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ door: "", feature: "" });

  const load = async () => {
    setLoading(true);
    try {
      const t = localStorage.getItem("kcis_admin_token");
      const r = await axios.get(`${API}/admin/interests`, {
        params: { ...filter }, headers: { Authorization: `Bearer ${t}` },
      });
      setData(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Load failed"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [filter]);

  return (
    <div className="min-h-screen bg-[#FBF8F2]">
      <UniHeader title="Admin · Placeholder Interest Leads" back="/admin/dashboard" />
      <main className="max-w-6xl mx-auto px-6 py-10" data-testid="admin-interests-page">
        <div className="flex items-center gap-3 mb-4">
          <Sparkles className="w-3.5 h-3.5 text-purple-900" />
          <h1 className="font-display text-2xl text-slate-900">Interest Captures</h1>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-3 mb-4 flex items-center gap-2">
          <input value={filter.door} onChange={(e) => setFilter((s) => ({...s, door: e.target.value}))} placeholder="Filter by door" className="rounded-xl border border-slate-200 h-9 px-2 text-sm" />
          <input value={filter.feature} onChange={(e) => setFilter((s) => ({...s, feature: e.target.value}))} placeholder="Filter by feature" className="rounded-xl border border-slate-200 h-9 px-2 text-sm" />
          <button onClick={load} className="text-xs text-purple-900 hover:underline inline-flex items-center gap-1"><RefreshCcw className="w-3 h-3" />Refresh</button>
        </div>

        {loading || !data ? <Loader2 className="w-4 h-4 animate-spin" /> : (
          <>
            <section className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <Agg title="By Door" map={data.by_door} testid="agg-door" />
              <Agg title="By Feature" map={data.by_feature} testid="agg-feature" />
              <Agg title="By Date" map={data.by_day} testid="agg-day" />
            </section>
            <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="interests-list">
              <div className="text-xs uppercase tracking-wide text-slate-500 mb-3">{data.count} captures</div>
              {data.items.length === 0 ? <div className="text-sm text-slate-500 italic">No interest captures yet. They'll appear here when visitors click "Notify me when ready" on placeholder pages.</div> : (
                <ul className="divide-y divide-slate-100">
                  {data.items.map((i) => (
                    <li key={i.id} className="py-3 flex items-center justify-between gap-3 text-sm">
                      <div className="min-w-0">
                        <div className="text-slate-900 flex items-center gap-2"><Mail className="w-3 h-3 text-purple-900" />{i.email}{i.name ? ` · ${i.name}` : ""}</div>
                        <div className="text-[11px] text-slate-500">{i.door || "—"} · {i.feature || i.route || "—"} {i.note ? `· ${i.note}` : ""}</div>
                      </div>
                      <div className="text-[11px] text-slate-400">{(i.created_at || "").slice(0,16).replace("T", " ")}</div>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </>
        )}
      </main>
    </div>
  );
}

function Agg({ title, map, testid }) {
  const entries = Object.entries(map || {}).sort((a, b) => b[1] - a[1]).slice(0, 8);
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={testid}>
      <div className="text-[11px] uppercase tracking-wide text-slate-500 mb-2">{title}</div>
      {entries.length === 0 ? <div className="text-xs text-slate-400 italic">None yet.</div> : (
        <ul className="text-sm space-y-1.5">
          {entries.map(([k, v]) => (
            <li key={k} className="flex items-center justify-between"><span className="text-slate-700 truncate">{k}</span><span className="font-mono text-slate-900">{v}</span></li>
          ))}
        </ul>
      )}
    </div>
  );
}
